import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Logo from 'components/common/LogoLogin';
// import Logo from 'components/common/LogoLogin';
import Section from 'components/common/Section';
import { Outlet } from 'react-router-dom';

const AuthSimpleLayout = () => {
  const videoContainerStyle = {
    position: 'fixed', // Fixa o vídeo na viewport
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: -1, // Coloca o vídeo atrás de outros elementos
    overflow: 'hidden' // Esconde partes do vídeo que excedem o container
  };

  const iframeStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '100vw', // Garante que cubra a largura
    height: '56.25vw', // Mantém a proporção 16:9 (100 / 16 * 9)
    minHeight: '100vh', // Garante que cubra a altura mínima
    minWidth: '177.77vh', // Garante que cubra a largura mínima (100 / 9 * 16)
    transform: 'translate(-50%, -50%)', // Centraliza o vídeo
    pointerEvents: 'none' // Impede interação com o vídeo
  };

  const videoUrl =
    'https://www.youtube.com/embed/wllYbJSnV8U?enablejsapi=1&disablekb=1&controls=0&rel=0&iv_load_policy=3&cc_load_policy=0&playsinline=1&showinfo=0&modestbranding=1&fs=0&origin=https://voxgroupbrasil.com&mute=1&autoplay=1&loop=1&playlist=wllYbJSnV8U'; // Adicionado playlist=VIDEO_ID para loop funcionar

  return (
    <Section
      className="py-0"
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      {' '}
      {/* Necessário para posicionamento absoluto do filho */}
      {/* Container do Vídeo */}
      <div style={videoContainerStyle}>
        <iframe
          style={iframeStyle}
          src={videoUrl}
          title="YouTube video background"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={10} md={8} lg={6} xl={5}>
          <Card style={{ backgroundColor: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(70px)' }}> {/* Fundo transparente suave com desfoque */}
            <Logo width={300} className="mt-3" />

            <Card.Body className="p-4 p-sm-5">
              <Outlet />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default AuthSimpleLayout;
